import api from './client';
import { IndexingJob, IndexingJobStatus } from '../types';

export interface IndexingJobsResponse {
  /** Liczniki globalne (wszystkie zadania, nie tylko zwrócona strona). */
  counts: Record<IndexingJobStatus, number>;
  /** Najnowsze zadania (domyślnie max 200). */
  jobs: IndexingJob[];
}

export const indexingApi = {
  list: () => api.get<IndexingJobsResponse>('/api/admin/indexing-jobs'),
  retry: (documentationId: string, tier?: string) =>
    api.post<IndexingJob>(
      `/api/admin/indexing-jobs/${documentationId}/retry`,
      null,
      { params: tier ? { tier } : undefined },
    ),
};
